import React from 'react';
import * as helpers from '../helpers';

export const withFieldProps = Wrapped => props =>
    <Wrapped
        enableSelfValueChange={true}
        format={helpers.fromTimestamp}
        parse={helpers.parse}
        { ...props }
    />;
